var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames,on:{"click":function($event){return _vm.onHeadlineClick(_vm.id)}}},[_vm._v(" "+_vm._s(_vm.headline || _vm.group || _vm.name || _vm.project_name || _vm.client_name || 'N/A')+" "),(_vm.article_count)?_c('span',{staticClass:"text-sm"},[_vm._v("("+_vm._s(_vm.article_count)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }